import { Component, HostListener, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-product-details-images',
    templateUrl: './product-details-images.component.html',
    styleUrls: ['./product-details-images.component.scss']
})
export class ProductDetailsImagesComponent implements OnInit {
    @Input() product;
    @Input() discount;
    @Input() deviceType;

    showNav = true;
    showDots = true;
    slidesPerView = 1;
    showMainImage = false;

    constructor() {
    }

    ngOnInit(): void {
        this.setSliderOptions();
    }

    setSliderOptions() {
        if (this.deviceType === 'mobile') {
            this.showMainImage = false;
            this.showDots = true;
            this.showNav = false;
        } else if (this.deviceType === 'tablet') {
            this.showMainImage = false;
            this.showDots = true;
            this.showNav = false;
        } else if (this.deviceType === 'desktop') {
            this.showMainImage = true;
            this.showDots = false;
            this.slidesPerView = 4;
            this.showNav = true;
        }
    }

}
